(() => {
  $(document).on(
    "click",
    ".smart-lock-bundle-selector .item:not(.disabled)",
    function () {
      // update active styles
      $(this).siblings(".item").removeClass("active");
      $(this).addClass("active");

      // update selected option
      $(this)
        .closest(".option-wrapper")
        .find("label .sel")
        .text($(this).attr("data-sel-text") ?? $(this).attr("data-option"));

      // update and trigger dropdown
      // let options = [];
      // $(".option-wrapper .item.active").each(function () {
      //   options.push($(this).attr("data-option"));
      // });
      // const select = $("[name='variant_id']");
      // select.val(select.find(`[data-option='${options.join(" / ")}']`).val());
      // select.trigger("change");
      let variantName = "";
      $(".option-wrapper .item.active").each(function (index) {
        let name = "";

        const option = $(this).attr("data-option");

        switch (index) {
          // Door model
          case 0:
            name = option;
            break;

          // Door feature
          case 1:
            if (option === "Ultra") {
              name = " Ultra";
            }
            name += " Door Lock";
            break;

          // Door colour
          case 2:
            name = ` / ${option}`;
            break;

          // Gate model
          case 3:
            name = option;

            // look ahead to see if Ultra is selected
            const gateFeature = $(".option-wrapper")
              .eq(4)
              .find(".item.active")
              .attr("data-option");

            if (name === "Sentry Privacy" && gateFeature === "Ultra") {
              name = "Sentry Ultra Privacy";
            } else if (name === "Sentry" && gateFeature === "Ultra") {
              name = "Sentry Ultra";
            }

            // <-- missing previously
            name = ` / ${name}`;

            break;

          // Gate feature
          case 4:
            name = " Gate Lock";
            break;

          // Gate colour
          case 5:
            name = ` / ${option}`;
            break;
        }

        variantName += name;
      });
      const select = $("[name='variant_id']");
      const variant = select.find(`[data-option='${variantName}']`);
      if (variant.length) {
        select.val(variant.val());
        select.trigger("change");
      } else {
        console.error("Variant Not Found:", variantName);
      }
    },
  );

  $("[name='variant_id']").on("change", function () {
    // const url = new URL(window.location.href);
    // url.searchParams.set("variant", $(this).val());
    // window.history.replaceState(null, "", url.toString());

    const option = $(this).find(`option[value='${$(this).val()}']`);
    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr("data-stockNum",option.attr("data-stockNum"));
    updateManualStockAndRestock();
    $(".subtitle[data-variant_title]").text(option.attr("data-option") || "");

    /* removed this first for temp 
    if (option.attr("data-preorder")) {
      $("#initateCheckout").text("PRE-ORDER NOW");
    }
    */

    updateLinks();
    updatePrice();
    updateInstallment();
    updateVoucher();
    updateStockIndicator();

    //toggleATCbuttons();
    updateImage();
    updateLeadTime();
    //updateCheckoutBtn();
  });

  function toggleATCbuttons() {
    const atcButton = $("#AddToCart-button");
    const checkoutBtn = $("#initateCheckout");
    const soldOutBtn = $("#sold-out-btn");
    const stockNum = $("#currentSelection").attr("data-stocknum");

    const selValue = $("[name='variant_id']").val();
    const selOption = $(`[name='variant_id'] option[value='${selValue}']`);

    if (selOption.attr("data-available") == "true") {
      atcButton.show();
      checkoutBtn.show();
      soldOutBtn.addClass("hide");
    } else {
      atcButton.hide();
      checkoutBtn.hide();
      soldOutBtn.removeClass("hide");
    }

    if (stockNum == 3){
      $("#initateCheckout").text("PRE-ORDER NOW");
      $(".product-form__checkout").text("PRE-ORDER NOW");
      console.log('this should be preorder');
    } else {
      $("#initateCheckout").text("GET IT NOW");
      console.log('this changed bundle');
    }
  }

  function updateImage() {
    const value = $("[name='variant_id']").val();
    const option = $(`[name='variant_id'] option[value='${value}']`);
    const handle = option.attr("data-handle");

    $(".product-single__thumbnails-items").removeClass("active");
    $(".product-single__thumbnails-items." + handle).addClass("active");

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + handle + " a").addClass(
      "active-thumb",
    );

    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  function updateCurrentSelection() {
    const value = $("[name='variant_id']").val();
    const option = $("[name='variant_id']").find(`option[value='${value}']`);
    $("#currentSelection").attr("data-variant", $("[name='variant_id']").val());
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));

    var readyStateCheckInterval = setInterval(function () {
      if (document.readyState === "complete") {
        clearInterval(readyStateCheckInterval);
        updateLinks();
        updatePrice();
        updateInstallment();
        updateVoucher();
      }
    }, 10);
  }
  function updateManualStockAndRestock() {
    const activeOptions = $(".smart-lock-bundle-selector .option-wrapper .item.active")
      .map(function () {
        return $(this).attr("data-option");
      })
      .get();

    const [
      doorModel,
      doorFeature,
      doorColour,
      gateModel,
      gateFeature,
      gateColour,
    ] = activeOptions;

    const preorderSpectre =
      doorModel === "Spectre" &&
      doorFeature === "Standard" &&
      doorColour === "Copper Rose";

    const preorderSentry =
      gateModel === "Sentry" &&
      gateFeature === "Standard" &&
      gateColour === "Onyx Black";

    const currentSelection = $("#currentSelection");

    if (preorderSpectre || preorderSentry) {
      currentSelection
        .attr("data-stocknum", "3")
        .attr("data-restock", "Delivers from 16 November");
      $('.product-restocks').html('<span class="text-center" style="display: block">Delivers from 16 November</span>');
    } else {
      // Restore the values from the selected variant's metafields.
      const variant = $("[name='variant_id'] option:selected");

      currentSelection
        .attr("data-stocknum", variant.attr("data-stocknum"))
        .attr("data-restock", variant.attr("data-restock") || "");
    }
  }
  function updateLeadTime() {
    const option = $(
      `[name='variant_id'] option[value="${$("[name='variant_id']").val()}"]`,
    );

    if (option.attr("data-restock")) {
      $(".custom-attributes.product-restocks p").html(
        option.attr("data-restock"),
      );
    }
  }

  function updateCheckoutBtn() {
    const option = $(
      `[name='variant_id'] option[value="${$("[name='variant_id']").val()}"]`,
    );

    if (option.attr("data-checkout")) {
      $("#initateCheckout").text(option.attr("data-checkout"));
    }
    console.log('checkoutbtn change again');
  }

  //toggleATCbuttons();
  updateImage();
  updateCurrentSelection();
  updateLeadTime();
  //updateCheckoutBtn();

  $(window).on("load", function () {
    setTimeout(() => {
      $("[name='variant_id']").trigger("change");
    }, 300);
  });
})();
